import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { storyFeaturesQueryOptions } from 'data/story-features';
import { type RoutePath, useLocalSearchParams } from 'expo-router';
import { getIsInSidebar } from 'platform-specific/url';
import { SkeletonConversationScreen } from 'structure/question/loading-screen';
import { SkeletonStandaloneConversationScreen } from 'structure/question/standalone-loading-screen';

const moduleFn = () => import('feature/article/article-module');

export const unstable_settings = {
    initialRouteName: 'index',
};

export function SuspenseFallback() {
    return <ArticleLoadingScreen />;
}

export default function ArticleInstanceMainLayout() {
    const { siloKey, instanceKey: decodedInstanceKey } =
        useLocalSearchParams<Extract<RoutePath, `/[siloKey]/article/[instanceKey]${string}`>>();
    // Legacy routing code did not perform encoding/decoding of path parameters.
    // Article instance keys need to be re-encoded before use.
    const instanceKey = encodeURIComponent(decodedInstanceKey);
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'article',
        instanceKey,
        featuresSource: storyFeaturesQueryOptions,
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig} loadingScreen={<ArticleLoadingScreen />}>
            <InstanceStack />
        </DatastoreProvider>
    );
}

function ArticleLoadingScreen() {
    if (getIsInSidebar()) {
        return <SkeletonConversationScreen />;
    }

    return <SkeletonStandaloneConversationScreen />;
}
